module.exports = __webpack_public_path__ + "img/ico_feed_sicbo@3x.217357de.png";